export default {
  'customerPickupScreenSettings.title': '取餐叫号屏',
  'customerPickupScreenSettings.language': '显示语言',
  'customerPickupScreenSettings.language.english': '英文',
  'customerPickupScreenSettings.language.englishAndChinese': '英文+简体中文',
  'customerPickupScreenSettings.language.chinese': '简体中文',
  'customerPickupScreenSettings.headlineText': '标题文字',
  'customerPickupScreenSettings.headlineText.tips': '自定义取餐叫号屏的标题文字，可根据业态定义不同文案。',
  'customerPickupScreenSettings.headlineText.inProgressStatus': '准备中状态',
  'customerPickupScreenSettings.headlineText.readyStatus': '已完成状态',
  'customerPickupScreenSettings.headlineText.english': '英文',
  'customerPickupScreenSettings.headlineText.chinese': '中文',
  'customerPickupScreenSettings.screenTemplates': '屏幕模版',
  'customerPickupScreenSettings.screenTemplates.upload': '上传图片',
  'customerPickupScreenSettings.screenTemplates.ready': '请取餐',
  'customerPickupScreenSettings.screenTemplates.inProgress': '制作中',
  'customerPickupScreenSettings.screenTemplates.preview': '预览',
  'customerPickupScreenSettings.screenTemplates.apply.yes': '已应用',
  'customerPickupScreenSettings.screenTemplates.apply.no': '应用模版',
  'customerPickupScreenSettings.screenTemplates.upload.ads': '宣传图',
  'customerPickupScreenSettings.screenTemplates.upload.bg': '背景图',
  'customerPickupScreenSettings.screenTemplates.tooltip.template1':
    '支持 JPG、JPEG、GIF、PNG图片格式，大小3M以内；宣传图比例3:4，背景图比例1:1。',
  'customerPickupScreenSettings.screenTemplates.tooltip.template2':
    '支持 JPG、JPEG、GIF、PNG图片格式，大小3M以内；背景图比例16:9。',
  'customerPickupScreenSettings.screenTemplates.tooltip.template3':
    '支持 JPG、JPEG、GIF、PNG图片格式，大小3M以内；背景图比例16:9。',
  'customerPickupScreenSettings.screenTemplates.tooLargeSize': '图像大小需要在3M以内',
  'customerPickupScreenSettings.screenTemplates.wrongFileType': '图片格式只能为.jpeg, .gif, .png',
  'customerPickupScreenSettings.screenTemplates.uploadImageFailed': '处理图片失败，请重新操作',
  'customerPickupScreenSettings.screenTemplates.templatePreview': '模版预览',
  'customerPickupScreenSettings.screenTemplates.require': '请选择屏幕模版',
  'customerPickupScreenSettings.voiceCall': '语音叫号',
  'customerPickupScreenSettings.voiceCall.checkbox': '显示取餐号时，播报叫号语音',
  'customerPickupScreenSettings.voiceCall.listen': '试听',
  'customerPickupScreenSettings.voiceCall.tooltip.title': '语音播报内容：',
  'customerPickupScreenSettings.voiceCall.tooltip.1':
    '如您选择显示语言为“英文”或“英文+中文”，播报语音为：“Order #Ticket no.# is ready for pickup”。',
  'customerPickupScreenSettings.voiceCall.tooltip.2': '如您选择显示语言为“中文”，播报语音为：“#取餐号# 请您取餐”。',
  'customerPickupScreenSettings.displayMode': '显示方式',
  'customerPickupScreenSettings.browserMode': '浏览器方式',
  'customerPickupScreenSettings.browserMode.tips': '请在取餐叫号屏上，用浏览器访问此URL。',
  'customerPickupScreenSettings.appMode': 'App方式',
  'customerPickupScreenSettings.appMode.button': '下载APK安装文件',
  'customerPickupScreenSettings.appMode.tips': '请将APK安装文件拷贝到安卓智能设备中，打开文件安装。',
  'customerPickupScreenSettings.callingTimes': '叫号次数',
  'customerPickupScreenSettings.callingTimes.1': '叫号1次',
  'customerPickupScreenSettings.callingTimes.n': '叫号{callingTime}次',
};
